<?xml version="1.0" encoding="utf-8"?>
<svg class="svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 555 95.3" style="enable-background:new 0 0 555 95.3;" xml:space="preserve">
<polyline points="378.7,68.3 378.7,88.8 547.7,88.8 515.2,57.3 547.7,25.7 458.5,25.7 "/>
<path d="M378.7,88.8c0,0,18.6,0.6,45.7-4.7c27.1-5.3,34.1-15.8,34.1-15.8"/>
<polyline points="178.3,68.4 178.3,88.9 7.3,88.9 39.8,57.3 7.3,25.8 98.4,25.8 "/>
<path d="M178.3,88.9c0,0-18.6,0.6-45.7-4.7C105.5,79,98.5,68.5,98.5,68.5"/>
<rect x="98.4" y="5.3" width="359.7" height="63"/>
</svg>
